var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotInterested(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 76,
    viewBox: "0 0 252 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1012 42.6999C34.8634 49.8933 27.0755 61.696 37.2298 66.7193C39.3642 67.7752 47.5132 66.1355 49.9595 65.4363C55.5746 63.8316 54.6637 58.4726 54.2479 55.5139C53.4481 49.8235 51.4293 44.3459 44.7058 41.0198C43.0987 40.2248 39.6842 40.3971 37.7081 40.6748C35.1533 41.0339 35.8645 43.1431 35.453 44.4076",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76485 68.0568C5.68325 60.3608 4.60165 52.6648 3.52004 44.9688C3.41391 44.2137 3.30778 43.4585 3.20165 42.7034C3.157 42.3856 2.7688 41.5285 3.06768 41.7501C3.64032 42.1748 3.68195 42.8632 4.01868 43.4091C5.15909 45.258 6.50738 47.2884 7.79083 49.0522C13.3091 56.6357 20.1668 63.5332 27.3558 70.2758C28.1117 70.9847 28.9019 71.6827 29.7454 72.3385C30.1054 72.6184 30.1222 72.3989 30.1039 72.0798C29.6418 64.0377 28.2318 56.0926 27.8556 48.0375C27.8217 47.311 28.0577 46.5455 28.3526 45.8279C28.4447 45.6037 28.4646 45.1059 28.7173 44.975",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0858 37.8186C55.7074 36.5701 59.1452 34.8285 62.7485 33.5195C64.408 32.9166 66.2538 31.9852 68.0216 31.7367C69.0624 31.5905 70.1032 31.4442 71.144 31.2979C71.4415 31.2561 70.5327 31.5164 70.3618 31.5615C69.9238 31.6771 69.4924 32.4157 69.3174 32.7841",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7319 35.9766C61.4802 42.8685 64.4679 49.1264 67.0331 55.7157C67.3494 56.5281 67.9926 59.0574 67.8712 58.1936",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6022 28.3701C88.0959 31.883 89.8755 34.8873 90.5989 38.3194C91.2786 41.5439 91.8019 44.7543 92.2623 48.03C92.5811 50.2984 92.7529 52.4574 92.5821 54.6797C92.5449 55.1631 92.7779 58.4479 92.4971 56.4496",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6666 60.3251C90.6638 59.9039 93.661 59.4827 96.6582 59.0615C97.6748 58.9186 100.21 59.0493 100.601 57.8681",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9331 28.5277C85.4553 28.0327 88.9312 27.2246 92.4309 26.7327C93.5032 26.582 95.5539 26.2768 96.3735 25.5394",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.565 27.5845C105.799 36.3635 110.12 62.6059 108.886 53.8269",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.831 27.2276C105.272 30.3655 105.749 33.0387 107.598 35.6644C109.448 38.2908 110.715 41.2819 112.547 43.8831C114.4 46.5143 115.907 49.3395 117.765 51.7623C118.869 53.202 117.674 48.0981 117.247 46.3302C116.119 41.66 115.234 36.7543 113.818 32.1798C112.765 28.7767 112.153 25.3271 111.656 21.7935",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M122.328 23.4895C121.095 14.713 127.262 58.5955 126.029 49.819",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.579 22.3413C120.346 21.5307 126.06 24.2437 131.806 23.4362",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M138.317 22.521C138.673 25.0518 139.029 27.5826 139.384 30.1134C139.682 32.2321 139.98 34.3508 140.278 36.4694C140.555 38.446 140.331 40.273 140.47 42.2136C140.598 43.9945 140.878 46.3588 140.473 48.1088C140.311 48.8074 140.188 49.3333 140.29 50.0524C140.348 50.4713 140.165 49.3004 140.226 49.1024C140.955 46.7342 145.673 47.0583 147.577 46.7907C148.573 46.6507 148.755 46.4473 149.1 47.3758C149.336 48.0114 151.81 48.7388 152.028 48.0831",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M140.7 34.9717L148.141 33.9259",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M138.671 22.791L147.973 21.4838",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M153.378 19.4455C153.886 23.0589 154.29 26.5179 155.626 29.9439C157.046 33.5829 158.08 37.2776 159.183 41.0043C159.874 43.3378 160.233 45.7276 160.575 48.1603",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M154.437 24.7305C154.356 24.158 154.172 23.5001 154.182 22.9195C154.199 21.9487 157.5 22.2552 158.038 22.3598C161.44 23.0204 163.88 24.9466 165.684 27.7668C167.905 31.2386 166.218 34.0195 162.141 34.1781C161.185 34.2153 161.092 33.4995 160.375 33.2365C159.218 32.8118 161.468 33.7744 161.74 33.9503C163.558 35.127 165.085 36.3577 166.498 38.0584C168.087 39.9706 171.151 42.4222 171.517 45.0244",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M169.014 15.9697C170.046 23.3073 171.377 30.5295 172.408 37.8674C172.51 38.5949 172.572 39.3413 172.717 40.0616C172.835 40.6551 174.612 40.0979 175 40.0603C177.648 39.8036 180.498 41.6228 183.123 42.1151",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M172.813 29.4992C170.956 29.7602 176.544 29.0862 178.418 29.0133C179.456 28.973 180.625 28.4392 181.583 28.906",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M168.526 16.9971C170.898 16.6638 173.038 16.4698 175.436 16.6653C177.045 16.7965 178.581 16.8625 180.175 16.6386",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M195.142 19.6489C194.916 18.0429 195.076 16.2403 193.728 15.2129C192.186 14.0374 189.266 15.5455 188.058 16.4892C185.703 18.3306 186.512 21.2352 186.874 23.812C186.987 24.6137 186.894 26.8038 187.691 27.2487C188.947 27.9501 190.658 27.4231 192.046 27.6134C193.531 27.8169 195.003 28.0137 196.444 28.4158C197.6 28.7379 199.932 29.3626 200.69 30.3762C202.171 32.3575 202.352 37.6854 200.245 39.211C197.845 40.9483 195.759 41.7205 192.842 42.0272C191.158 42.2044 188.303 41.5652 189.37 39.3188",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M204.361 11.002C205.118 16.3869 206.514 21.6064 208.227 26.7602C209.797 31.4879 210.732 36.0866 211.424 41.0141",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M192.092 11.4477C197.26 10.7215 202.427 9.99521 207.595 9.26896C209.854 8.95143 212.653 8.97044 214.682 7.95328",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M214.101 15.0669C215.16 22.5993 216.563 30.0078 217.883 37.4783C217.973 37.9853 218.25 38.7325 218.46 39.2085C218.555 39.4234 219.581 38.0948 219.841 37.9134C221.652 36.654 223.792 36.3993 225.91 36.1015",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M215.687 26.3506L222.198 25.4355",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M213.525 15.4677C217.33 14.933 221.256 14.0616 224.953 13.542",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M222.568 5.56604C223.988 5.52658 225.841 7.50146 226.906 8.31254C229.123 10.0025 230.686 11.7191 231.935 14.2293C234.445 19.2714 235.366 24.6374 236.146 30.1877C236.43 32.2096 235.865 33.7506 235 35.534C234.801 35.9434 233.144 37.6687 233.597 36.2994C233.912 35.3477 235.874 34.4825 236.755 34.2751C239.326 33.6696 241.868 33.4412 244.342 32.392C248.735 30.5291 249.352 27.417 248.724 22.9506C247.853 16.7507 246.311 11.1865 241.571 6.8019C239.171 4.58156 235.094 0.811687 231.683 3.18397C230.263 4.17132 228.706 4.70647 227.419 5.84307C226.81 6.38156 226.593 7.63631 226.198 6.65395",
    stroke: "#FF1569",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotInterested);
export default __webpack_public_path__ + "static/media/not-interested.f493741a6a61d4a1dc49fe9c9487c3d7.svg";
export { ForwardRef as ReactComponent };